import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {UserService} from '../../../../services/user-services/user.service';
import {AuthenticationService} from '../../../../services/authentication.service';
import {LocalSettingsService} from 'src/app/services/local-settings.service';
import {SocialAuthService, SocialUser} from '@abacritt/angularx-social-login';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {SchoolService} from '../../../../services/school.service';
import {GlobalConstantsComponent} from '../../../global-constants/global-constants.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ModaleRegisterComponent} from './modale-register/modale-register.component';
import {ModaleLoginComponent} from './modale-login/modale-login.component';
import {GoogleSigninButtDirective} from '../../../../directives/google-signin-butt.directive';
import {NgClass, NgIf} from '@angular/common';
import {GoogleSigninComponent} from '../../google-signin/google-signin.component';
import {AlertService} from '../../../../services/alert.service';


@Component({
  selector: 'app-form-login',
  templateUrl: './form-login.component.html',
  styleUrls: ['./form-login.component.scss'],
  standalone: true,
  imports: [NgIf, GoogleSigninButtDirective, ModaleLoginComponent, ModaleRegisterComponent, TranslateModule, GoogleSigninComponent, NgClass, RouterLink]
})
export class FormLoginComponent implements OnInit, OnDestroy {

  @Input() showSchoolLogo: boolean = false;
  @Input() bigTitle: string = '';
  @Input() smallTitle: string = '';
  @Input() showAsset: boolean = false;
  @Output() clicked = new EventEmitter<string>();


  public openedModal: string;
  public slug: string;
  public returnUrl: string;
  public showGoogleLogin = true;
  public school;
  private mediaPath = GlobalConstantsComponent.mediaURL + 'schools/';
  public schoolBackgroundUrl: string = 'assets/img/register/register_bg.webp';
  public schoolLogo: string;
  public socialUser!: SocialUser;
  public oAuthUser;
  public isClicked = false;
  private _subs$ = [];
  grey = 'en';
  currentLanguage;

  constructor(
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private _localSettings: LocalSettingsService,
    private socialAuthService: SocialAuthService,
    private route: ActivatedRoute,
    private router: Router,
    private schoolService: SchoolService,
    private modalService: NgbModal,
    public translate: TranslateService,
    private alertService: AlertService,
  ) {
    const schoolSlug = this.route.snapshot.paramMap.get('schoolSlug');
    this.slug = schoolSlug;
    if (schoolSlug === 'register' || schoolSlug === 'account' || schoolSlug === 'login' || !schoolSlug) {
      this.slug = 'livinfrance';
    }
    this.route.queryParams.subscribe(params => {
      //UTM
      if (params && (params['utm_campaign'] || params['utm_source'] || params['utm_medium'])) {
        const utm = [
          { key: 'utm_campaign', value: params['utm_campaign'] ? params['utm_campaign'] : '' },
          { key: 'utm_source', value: params['utm_source'] ? params['utm_source'] : '' },
          { key: 'utm_medium', value: params['utm_medium'] ? params['utm_medium'] : '' },
        ];
        this._localSettings.setUtm(JSON.stringify(utm));
      }

      if (params && params['campaign']) {
        this._localSettings.setReferer(params['campaign']);
      }
      if (params && params['click_id']) {
        this._localSettings.setClickid(params['clickid']);
      }
      if (params && params['returnUrl']) {
        this.returnUrl = this.translate.currentLang + params['returnUrl'];
      } else {
        if (!this.router.url.endsWith('login') && !this.router.url.endsWith('register')) {
          this.returnUrl = this.router.url.slice(1, this.router.url.length);
        } else {
          this.returnUrl = this.translate.currentLang + '/discover';
        }
      }
      if(this.returnUrl.includes('/en') || this.returnUrl.includes('/fr')){
        this.returnUrl = this.returnUrl.slice(3, this.returnUrl.length);
      }
    });
  }

  ngOnInit(): void {
    if (this.authenticationService.currentUserValue) {
      this.router.navigate([this.returnUrl]);
    } else {
      this.schoolService.getBySlug(this.slug).subscribe((data: any) => {
        this.school = data;
        if (this.school.slug !== 'harvard' && this.school.slug !== 'livinfrance') {
          this.schoolBackgroundUrl = this.mediaPath + this.school.background_image;
          this.schoolLogo = this.mediaPath + this.school.logo;
        }
      });
    }
  }

  // Modals
  public open(name): void {
    this.openedModal = name;
  }

  ngOnDestroy(): void {
    this._subs$.forEach(s => {
      if (s) {
        s.unsubscribe();
      }
    });
  }

  isGoogleClick(): void {
    this._subs$.push(this.socialAuthService.authState.subscribe((user) => {
      if (user) {
        this.socialUser = user;
        this.oAuthUser = this.socialUser;
        this._subs$.push(this.userService.checkExist(this.socialUser.email).subscribe((value) => {
          if (value) {
            this._subs$.push(this.authenticationService
              .login(this.socialUser.email, this.socialUser.idToken, this.slug, user.photoUrl)
              .subscribe(
                (data) => {
                  if (data.status == 'error') {
                    this.alertService.openSnackBar('', 'snack-error');
                  }
                  if (data.data.token) {
                    this.modalService.dismissAll();
                    if (this.returnUrl) {
                      if (this.router.url !== '/' + this.returnUrl) {
                        this.router.navigate([this.returnUrl]);
                      } else {
                        window.location.hash = 'reload';
                        window.location.reload();
                      }
                    } else {
                      this.router.navigate([this.translate.currentLang + '/discover']);
                    }
                  }
                }
              ));
          } else {
            this.open('register');
          }
        }));
      }
    }));
  }

  public useLanguage(language: string) {
    if(language != 'fr') language = 'en';
    this.translate.use(language);
    this.currentLanguage = language;
    this._localSettings.setLanguage(language);
  }

  flagToggle(current) {
    this.grey = current;
  }


}
